import { Guid, Nillable } from '@web/utils';
import { Multimedia } from '@web/shared/module/multimedia';
import { PublicCosmeticCharacteristic } from './public-cosmetic-characteristic';
import { PublicCosmeticAttribute } from './public-cosmetic-attribute';
import { PublicCosmeticBrand } from './public-cosmetic-brand';
import { PublicCosmeticBox } from './public-cosmetic-box';

export class PublicCosmeticDetails {
  public constructor(
    private readonly data: {
      attributes: PublicCosmeticAttribute[];
      characteristics: PublicCosmeticCharacteristic[];
      cosmeticBrand: PublicCosmeticBrand;
      files: Multimedia[];
      id: Guid;
      name: string;
      slug: string;
      vendorUrl?: Nillable<string>;
      box?: Nillable<PublicCosmeticBox>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get vendorUrl(): Nillable<string> {
    return this.data.vendorUrl;
  }

  public get cosmeticBrand(): PublicCosmeticBrand {
    return this.data.cosmeticBrand;
  }

  public get files(): Multimedia[] {
    return this.data.files;
  }

  public get characteristics(): PublicCosmeticCharacteristic[] {
    return this.data.characteristics;
  }

  public get attributes(): PublicCosmeticAttribute[] {
    return this.data.attributes;
  }

  public get box(): Nillable<PublicCosmeticBox> {
    return this.data.box;
  }
}
